// Badge color for the "Complet à X%" pill on the product list.
//
// A product page is only complete at 100%, so anything below is flagged orange
// rather than green; at or under CRITICAL the gaps are severe enough to warrant
// red. Returns a Badge `color` variant, not a raw hex.

// at or below this share of passing validation checks, the gaps are critical
export const COMPLETENESS_CRITICAL = 20;

export function completenessColor(value) {
    if (value <= COMPLETENESS_CRITICAL) {
        return 'error';
    }

    return 100 <= value ? 'online' : 'warning';
}

export default completenessColor;
